import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import {
  MdEmail,
  MdLock,
  MdVisibility,
  MdVisibilityOff,
  MdArrowForward,
} from "react-icons/md";
import "../../../assets/css/seller/auth/SellerLogin.css";
import axios from "axios";
import AppContext from "../../../contexts/AppContext.js";
import LoadingScreen from "../../../components/general/animations/Animations.js";

const SellerLogin = () => {
  const navigate = useNavigate();
  const { baseUrl, setSellerToken, setSeller } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

 const autoLoginSeller = (savedEmail, savedPassword) => {
  setLoginLoading(true);
  const formData = new FormData();
  formData.append("email", savedEmail);
  formData.append("password", savedPassword);

  axios
    .post(`${baseUrl}/seller/login`, formData)
    .then((response) => {
      if (response.data.seller != null) {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("loggedInSeller", JSON.stringify(response.data.seller));
        setSellerToken(response.data.token);
        setSeller(response.data.seller);
        navigate("/seller/dashboard");
      } else {
        localStorage.removeItem("loggedInSeller");
        localStorage.removeItem("authToken");
      }
      setLoginLoading(false);
      setPageLoading(false);
    })
    .catch((error) => {
      console.log(error);
      localStorage.removeItem("loggedInSeller");
      localStorage.removeItem("authToken");
      setLoginLoading(false);
      setPageLoading(false);
    });
};

  const sellerLogin = () => {
    setErrorMessage("");
    setLoginLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/seller/login`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.seller == null) {
          setLoginLoading(false);
          setErrorMessage("Invalid email or password");
        } else {
          setLoginLoading(false);
          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify({
              ...response.data.seller,
              password: password,
            }),
          );
          setSellerToken(response.data.token);
          setSeller(response.data.seller);
          navigate("/seller/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoginLoading(false);
        setErrorMessage("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    const savedSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    if (savedSeller) {
      setPageLoading(false);
      autoLoginSeller(savedSeller.email, savedSeller.password);
    } else {
      setTimeout(() => {
        setPageLoading(false);
      }, 2500);
    }
  }, []);

  const handleSignUpClick = () => navigate("/seller/signup");

  if (pageLoading || loginLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="seller-login-glassmorphism-container">
      <div className="seller-login-background-circles">
        <div className="seller-login-circle seller-login-circle-1"></div>
        <div className="seller-login-circle seller-login-circle-2"></div>
        <div className="seller-login-circle seller-login-circle-3"></div>
        <div className="seller-login-circle seller-login-circle-4"></div>
      </div>

      <Container fluid className="seller-login-page-wrapper">
        <Row className="seller-login-row w-100 g-0 align-items-center">
          {/* LEFT — BRAND SECTION */}
          <Col xl={6} lg={6} md={12} xs={12} className="seller-login-brand-section">
            <div className="seller-login-logo-container">
              <h1 className="seller-login-logo-text">CRAFTHIVE</h1>
              <p className="seller-login-logo-subtitle">Seller Portal</p>
            </div>
            <h2 className="seller-login-main-heading">
              Welcome Back to Your Craft Business
            </h2>
            <p className="seller-login-description-text">
              Pick up right where you left off. Manage your products, track
              your orders, and keep growing your craft business with
              CraftHive.
            </p>
          </Col>

          {/* RIGHT — FORM SECTION */}
          <Col xl={6} lg={6} md={12} xs={12} className="seller-login-form-section">
            <div className="seller-login-glass-card">
              <h3 className="seller-login-form-title text-center">
                WELCOME BACK SELLER
              </h3>
              <p className="seller-login-form-subtitle text-center mb-4">
                Login to your seller account
              </p>

              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  sellerLogin();
                }}
              >
                {errorMessage && (
                  <div className="alert alert-danger mb-3">{errorMessage}</div>
                )}

                <Form.Group className="mb-3">
                  <InputGroup>
                    <InputGroup.Text className="seller-login-input-icon">
                      <MdEmail size={18} />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrorMessage("");
                      }}
                      className="seller-login-glass-input"
                      required
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-3">
                  <InputGroup>
                    <InputGroup.Text className="seller-login-input-icon">
                      <MdLock size={18} />
                    </InputGroup.Text>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setErrorMessage("");
                      }}
                      className="seller-login-glass-input"
                      required
                    />
                    <Button
                      variant="link"
                      className="seller-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <MdVisibilityOff size={18} />
                      ) : (
                        <MdVisibility size={18} />
                      )}
                    </Button>
                  </InputGroup>
                </Form.Group>

                <Button
                  type="submit"
                  disabled={loginLoading}
                  className="seller-login-button w-100 d-flex align-items-center justify-content-center gap-2"
                >
                  {loginLoading ? "LOGGING IN..." : "LOGIN"}
                  <MdArrowForward size={18} />
                </Button>
              </Form>

              <p className="seller-signup-link-text text-center mt-4">
                Don't have a seller account?{" "}
                <Button
                  variant="link"
                  onClick={handleSignUpClick}
                  className="seller-signup-link p-0"
                >
                  Sign Up
                </Button>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SellerLogin;